<template>
  <div class="saved-filters-list">
    <div
      class="saved-filters-list__item"
      v-for="filter in savedFilters"
      :key="filter.title"
    >
      <SavedFilterItem
        :filter="filter"
        @click.prevent="$emit('click', filter)"
        @remove="$emit('remove', filter)"
      />
    </div>
  </div>
</template>

<script>
  import SavedFilterItem from "src/components/filters/SavedFilterItem/SavedFilterItem.vue";

  export default {
    name: 'SavedFiltersList',
    components: { SavedFilterItem },
    props: {
      savedFilters: {
        type: Array,
        required: true,
      }
    }
  }
</script>